<template>
  <main>
    <div class="section-dashboard">
      <div class='section-dashboard-left'>
        <div class='section-dashboard-border'>
          <div>
            <h4 class="font-weight-bolder" v-once>Dashboard</h4>
            <h5 style="font-size: 14px; color: #374151; margin-bottom: 15px; font-weight: normal;">Para visualizar informações sobre um município especifico, selecione o município no mapa abaixo:</h5>
          </div>

          <div class='section-dashboard-border-map'>
            <div style="width: 40%;">
              <b-form-group
                label-class="font-weight-bolder"
                style="margin-bottom: 0;"
              >
                <b-form-select
                  v-model="selectedMunicipio"
                  :options="municipios"
                >
                </b-form-select>
              </b-form-group>
            </div>

            <div style="display: flex; align-items: center; justify-content: center;">
              <Map :selectedMunicipio="selectedMunicipio" :changeMunicipio="changeMunicipio" />
            </div>
          </div>

          <div class='section-dashboard-alone-item-bottom' style="display: flex; justify-content: center; height: auto; align-items: center; border-radius: 10px; border: 2px solid #9CA3AF; border-color: #015675; padding: 10px;">
              <div style="margin-top: 15px; margin-bottom: 15px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                <div style="display: flex; align-items: center;">
                  <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.5833 29.3327C12.4121 29.3327 13.207 29.0034 13.793 28.4174C14.3791 27.8313 14.7083 27.0365 14.7083 26.2077C14.7185 26.1038 14.7185 25.9991 14.7083 25.8952L20.5208 20.0827H21H21.4792L24.8333 23.4369C24.8333 23.4369 24.8333 23.541 24.8333 23.6035C24.8333 24.4323 25.1626 25.2272 25.7486 25.8132C26.3347 26.3993 27.1295 26.7285 27.9583 26.7285C28.7871 26.7285 29.582 26.3993 30.168 25.8132C30.7541 25.2272 31.0833 24.4323 31.0833 23.6035V23.4369L38.6667 15.791C39.2847 15.791 39.8889 15.6077 40.4028 15.2644C40.9167 14.921 41.3173 14.4329 41.5538 13.8619C41.7903 13.2909 41.8522 12.6625 41.7316 12.0564C41.611 11.4502 41.3134 10.8933 40.8764 10.4563C40.4393 10.0193 39.8825 9.72164 39.2763 9.60106C38.6701 9.48048 38.0418 9.54237 37.4708 9.77889C36.8998 10.0154 36.4117 10.416 36.0683 10.9299C35.7249 11.4438 35.5417 12.0479 35.5417 12.666C35.5315 12.7699 35.5315 12.8746 35.5417 12.9785L28.0208 20.4994H27.6875L24.0833 16.8327C24.0833 16.0039 23.7541 15.209 23.168 14.623C22.582 14.0369 21.7871 13.7077 20.9583 13.7077C20.1295 13.7077 19.3347 14.0369 18.7486 14.623C18.1626 15.209 17.8333 16.0039 17.8333 16.8327L11.5833 23.0827C10.7545 23.0827 9.95968 23.4119 9.37362 23.998C8.78757 24.584 8.45833 25.3789 8.45833 26.2077C8.45833 27.0365 8.78757 27.8313 9.37362 28.4174C9.95968 29.0034 10.7545 29.3327 11.5833 29.3327ZM39.7083 37.666H4.29167V2.24935C4.29167 1.69681 4.07217 1.16691 3.68147 0.77621C3.29077 0.385509 2.76087 0.166016 2.20833 0.166016C1.6558 0.166016 1.12589 0.385509 0.735194 0.77621C0.344493 1.16691 0.125 1.69681 0.125 2.24935V39.7494C0.125 40.3019 0.344493 40.8318 0.735194 41.2225C1.12589 41.6132 1.6558 41.8327 2.20833 41.8327H39.7083C40.2609 41.8327 40.7908 41.6132 41.1815 41.2225C41.5722 40.8318 41.7917 40.3019 41.7917 39.7494C41.7917 39.1968 41.5722 38.6669 41.1815 38.2762C40.7908 37.8855 40.2609 37.666 39.7083 37.666Z" fill="#015675"/>
                  </svg>

                  <h1 style="font-size: 32px; margin-left: 5px; color: #015675; font-weight: bold; margin-left: 20px;">{{ moneyMask(graph.valor_total_termo_convenio) }}</h1>
                </div>

                <h1 style="font-size: 20px; text-align: center; color: #015675; font-weight: bold;">Valor total do termo do Convênio</h1>
              </div>
            </div>

          <div class='section-dashboard-bottom'>
            <div class='section-dashboard-item-bottom' :style="graph.termos.eixos.open ? 'height: auto;' : 'height: auto; justify-content: center;'" @click="graph.termos.eixos.open = graph.termos.eixos.open" style=" display: flex; flex-direction: column; border-radius: 10px; border: 2px solid #9CA3AF; border-color: #0fb899; padding: 10px;">
              <div style="display: flex; flex-direction: column; width: 100%; justify-content: center;">
                <div style="display: flex; flex-direction: column; width: 100%; justify-content: center;">
                  <div style="display: flex; align-items: center; justify-content: center;" :style="graph.termos.eixos.open && 'margin-top: 10px;'">
                    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 8.49935C20.4475 8.49935 19.9176 8.71884 19.5269 9.10954C19.1362 9.50025 18.9167 10.0301 18.9167 10.5827V31.416C18.9167 31.9686 19.1362 32.4985 19.5269 32.8892C19.9176 33.2799 20.4475 33.4994 21 33.4994C21.5526 33.4994 22.0825 33.2799 22.4732 32.8892C22.8639 32.4985 23.0834 31.9686 23.0834 31.416V10.5827C23.0834 10.0301 22.8639 9.50025 22.4732 9.10954C22.0825 8.71884 21.5526 8.49935 21 8.49935ZM10.5834 20.9994C10.0308 20.9994 9.50092 21.2188 9.11022 21.6095C8.71951 22.0002 8.50002 22.5301 8.50002 23.0827V31.416C8.50002 31.9686 8.71951 32.4985 9.11022 32.8892C9.50092 33.2799 10.0308 33.4994 10.5834 33.4994C11.1359 33.4994 11.6658 33.2799 12.0565 32.8892C12.4472 32.4985 12.6667 31.9686 12.6667 31.416V23.0827C12.6667 22.5301 12.4472 22.0002 12.0565 21.6095C11.6658 21.2188 11.1359 20.9994 10.5834 20.9994ZM31.4167 16.8327C30.8642 16.8327 30.3342 17.0522 29.9435 17.4429C29.5528 17.8336 29.3334 18.3635 29.3334 18.916V31.416C29.3334 31.9686 29.5528 32.4985 29.9435 32.8892C30.3342 33.2799 30.8642 33.4994 31.4167 33.4994C31.9692 33.4994 32.4991 33.2799 32.8898 32.8892C33.2805 32.4985 33.5 31.9686 33.5 31.416V18.916C33.5 18.3635 33.2805 17.8336 32.8898 17.4429C32.4991 17.0522 31.9692 16.8327 31.4167 16.8327ZM35.5834 0.166016H6.41669C4.75908 0.166016 3.16937 0.824496 1.99727 1.9966C0.825168 3.1687 0.166687 4.75841 0.166687 6.41602V35.5827C0.166687 37.2403 0.825168 38.83 1.99727 40.0021C3.16937 41.1742 4.75908 41.8327 6.41669 41.8327H35.5834C37.241 41.8327 38.8307 41.1742 40.0028 40.0021C41.1749 38.83 41.8334 37.2403 41.8334 35.5827V6.41602C41.8334 4.75841 41.1749 3.1687 40.0028 1.9966C38.8307 0.824496 37.241 0.166016 35.5834 0.166016ZM37.6667 35.5827C37.6667 36.1352 37.4472 36.6651 37.0565 37.0558C36.6658 37.4465 36.1359 37.666 35.5834 37.666H6.41669C5.86415 37.666 5.33425 37.4465 4.94355 37.0558C4.55285 36.6651 4.33335 36.1352 4.33335 35.5827V6.41602C4.33335 5.86348 4.55285 5.33358 4.94355 4.94288C5.33425 4.55218 5.86415 4.33268 6.41669 4.33268H35.5834C36.1359 4.33268 36.6658 4.55218 37.0565 4.94288C37.4472 5.33358 37.6667 5.86348 37.6667 6.41602V35.5827Z" fill="#0FB899"/>
                    </svg>

                    <h1 style="font-size: 32px; margin-left: 5px; color: #0FB899; font-weight: bold; margin-left: 20px;">{{ moneyMask(somarValores(graph.termos.eixos.data)) }}</h1>
                  </div>

                  <h1 style="font-size: 20px; text-align: center; color: #0FB899; font-weight: bold;">Valor total do termo por eixo</h1>
                </div>

                <div v-if="graph.termos.eixos.open" v-for="(item, index) in graph.termos.eixos.data" style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; background-color: #f9f9f9; padding: 10px; border-radius: 15px; margin-bottom: 5px;">
                  <h1 style="font-size: 14px; text-align: left; color: #0FB899; font-weight: bold; margin-bottom: 0;">{{ item.titulo }}</h1>
                  <h1 style="font-size: 14px; text-align: left; color: #0FB899; font-weight: bold; margin-bottom: 0;">{{ moneyMask(item.valor) }}</h1>
                </div>
              </div>
            </div>

            <div class='section-dashboard-item-bottom' :style="graph.termos.subeixos.open ? 'height: auto' : 'height: auto justify-content: center;'" @click="graph.termos.subeixos.open = graph.termos.subeixos.open" style=" display: flex; flex-direction: column; border-radius: 10px; border: 2px solid #9CA3AF; border-color: #2D8D76; padding: 10px;">
              <div style="display: flex; flex-direction: column; width: 100%; justify-content: center;">
                <div style="display: flex; flex-direction: column; width: 100%; justify-content: center;">
                  <div style="display: flex; align-items: center; justify-content: center;" :style="graph.termos.subeixos.open && 'margin-top: 10px;'">
                    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M39.75 25.166H37.6667V2.24935C37.6667 1.69681 37.4472 1.16691 37.0565 0.77621C36.6658 0.385509 36.1359 0.166016 35.5833 0.166016H6.41666C5.86412 0.166016 5.33422 0.385509 4.94352 0.77621C4.55282 1.16691 4.33332 1.69681 4.33332 2.24935V25.166H2.24999C1.69746 25.166 1.16755 25.3855 0.776851 25.7762C0.38615 26.1669 0.166656 26.6968 0.166656 27.2493C0.166656 27.8019 0.38615 28.3318 0.776851 28.7225C1.16755 29.1132 1.69746 29.3327 2.24999 29.3327H18.9167V31.7285L9.43749 37.9785C9.0486 38.2192 8.74974 38.5812 8.58701 39.0087C8.42428 39.4361 8.40673 39.9052 8.53706 40.3436C8.6674 40.782 8.93837 41.1653 9.30819 41.4345C9.678 41.7036 10.1261 41.8435 10.5833 41.8327C10.9929 41.8374 11.3937 41.7135 11.7292 41.4785L18.9167 36.7285V39.7493C18.9167 40.3019 19.1362 40.8318 19.5269 41.2225C19.9176 41.6132 20.4475 41.8327 21 41.8327C21.5525 41.8327 22.0824 41.6132 22.4731 41.2225C22.8638 40.8318 23.0833 40.3019 23.0833 39.7493V36.7285L30.2708 41.4785C30.6063 41.7135 31.0071 41.8374 31.4167 41.8327C31.8618 41.8292 32.2941 41.6833 32.6502 41.4164C33.0064 41.1494 33.2676 40.7753 33.3957 40.349C33.5239 39.9228 33.5121 39.4667 33.3621 39.0476C33.2122 38.6285 32.9319 38.2684 32.5625 38.0202L23.0833 31.7702V29.3327H39.75C40.3025 29.3327 40.8324 29.1132 41.2231 28.7225C41.6138 28.3318 41.8333 27.8019 41.8333 27.2493C41.8333 26.6968 41.6138 26.1669 41.2231 25.7762C40.8324 25.3855 40.3025 25.166 39.75 25.166ZM33.5 25.166H8.49999V4.33268H33.5V25.166ZM14.75 20.9993C15.0931 20.9976 15.4305 20.9111 15.7322 20.7475C16.0338 20.584 16.2904 20.3484 16.4792 20.0618L19.25 15.8952L21.6042 18.2702C21.8227 18.4901 22.0877 18.6585 22.3796 18.763C22.6716 18.8675 22.9831 18.9056 23.2917 18.8743C23.5988 18.8406 23.8946 18.739 24.1577 18.5769C24.4207 18.4147 24.6444 18.1961 24.8125 17.9368L28.9792 11.6868C29.2245 11.2294 29.2903 10.6969 29.1636 10.1935C29.0368 9.69009 28.7268 9.25215 28.2941 8.96542C27.8614 8.67868 27.3372 8.56381 26.8242 8.64331C26.3113 8.7228 25.8465 8.99093 25.5208 9.39518L22.75 13.5618L20.3958 11.1868C20.1772 10.9669 19.9123 10.7985 19.6204 10.694C19.3284 10.5895 19.0168 10.5515 18.7083 10.5827C18.4012 10.6164 18.1054 10.718 17.8423 10.8801C17.5793 11.0423 17.3556 11.2609 17.1875 11.5202L13.0208 17.7702C12.7193 18.2295 12.6114 18.7893 12.7207 19.3278C12.8299 19.8662 13.1475 20.3397 13.6042 20.6452C13.9397 20.8802 14.3404 21.004 14.75 20.9993Z" fill="#2D8D76"/>
                    </svg>

                    <h1 style="font-size: 32px; margin-left: 5px; color: #2D8D76; font-weight: bold; margin-left: 20px;">{{ moneyMask(somarValores(graph.termos.subeixos.data)) }}</h1>
                  </div>

                  <h1 style="font-size: 20px; text-align: center; color: #2D8D76; font-weight: bold;">Valor total do termo por subeixo</h1>
                </div>

                <div v-if="graph.termos.subeixos.open" v-for="(item, index) in graph.termos.subeixos.data" style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; background-color: #f9f9f9; padding: 10px; border-radius: 15px; margin-bottom: 5px;">
                  <h1 style="font-size: 14px; text-align: left; color: #2D8D76; font-weight: bold; margin-bottom: 0;">{{ item.titulo }}</h1>
                  <h1 style="font-size: 14px; text-align: left; color: #2D8D76; font-weight: bold; margin-bottom: 0; margin-left: 10px;">{{ moneyMask(item.valor) }}</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class='section-dashboard-right'>
        <div class='section-dashboard-right-item' style="display: flex; justify-content: center; align-items: center; height: 100%; border-radius: 10px; border: 2px solid #9CA3AF; border-color: #16A34A; padding: 10px;">
          <div style="margin-top: 15px; margin-bottom: 15px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <div style="display: flex; align-items: center;">
              <svg width="38" height="42" viewBox="0 0 38 42" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M27.3333 37.666H10.6667C9.00906 37.666 7.41935 37.0075 6.24725 35.8354C5.07515 34.6633 4.41667 33.0736 4.41667 31.416V10.5827C4.41667 10.0301 4.19717 9.50025 3.80647 9.10954C3.41577 8.71884 2.88587 8.49935 2.33333 8.49935C1.7808 8.49935 1.25089 8.71884 0.860194 9.10954C0.469493 9.50025 0.25 10.0301 0.25 10.5827V31.416C0.25 34.1787 1.34747 36.8282 3.30097 38.7817C5.25447 40.7352 7.90399 41.8327 10.6667 41.8327H27.3333C27.8859 41.8327 28.4158 41.6132 28.8065 41.2225C29.1972 40.8318 29.4167 40.3019 29.4167 39.7494C29.4167 39.1968 29.1972 38.6669 28.8065 38.2762C28.4158 37.8855 27.8859 37.666 27.3333 37.666ZM14.8333 23.0827C14.8333 23.6352 15.0528 24.1651 15.4435 24.5558C15.8342 24.9465 16.3641 25.166 16.9167 25.166H27.3333C27.8859 25.166 28.4158 24.9465 28.8065 24.5558C29.1972 24.1651 29.4167 23.6352 29.4167 23.0827C29.4167 22.5301 29.1972 22.0002 28.8065 21.6095C28.4158 21.2188 27.8859 20.9994 27.3333 20.9994H16.9167C16.3641 20.9994 15.8342 21.2188 15.4435 21.6095C15.0528 22.0002 14.8333 22.5301 14.8333 23.0827ZM37.75 14.6243C37.7283 14.433 37.6864 14.2444 37.625 14.0619V13.8743C37.5248 13.6601 37.3912 13.4632 37.2292 13.291L24.7292 0.791016C24.5569 0.628966 24.36 0.495351 24.1458 0.395182C24.0836 0.386349 24.0205 0.386349 23.9583 0.395182C23.7467 0.27381 23.513 0.195899 23.2708 0.166016H14.8333C13.1757 0.166016 11.586 0.824496 10.4139 1.9966C9.24181 3.1687 8.58333 4.75841 8.58333 6.41602V27.2494C8.58333 28.907 9.24181 30.4967 10.4139 31.6688C11.586 32.8409 13.1757 33.4994 14.8333 33.4994H31.5C33.1576 33.4994 34.7473 32.8409 35.9194 31.6688C37.0915 30.4967 37.75 28.907 37.75 27.2494V14.7493C37.75 14.7493 37.75 14.7493 37.75 14.6243ZM25.25 7.27018L30.6458 12.666H27.3333C26.7808 12.666 26.2509 12.4465 25.8602 12.0558C25.4695 11.6651 25.25 11.1352 25.25 10.5827V7.27018ZM33.5833 27.2494C33.5833 27.8019 33.3638 28.3318 32.9731 28.7225C32.5824 29.1132 32.0525 29.3327 31.5 29.3327H14.8333C14.2808 29.3327 13.7509 29.1132 13.3602 28.7225C12.9695 28.3318 12.75 27.8019 12.75 27.2494V6.41602C12.75 5.86348 12.9695 5.33358 13.3602 4.94288C13.7509 4.55218 14.2808 4.33268 14.8333 4.33268H21.0833V10.5827C21.089 11.2934 21.2158 11.9979 21.4583 12.666H16.9167C16.3641 12.666 15.8342 12.8855 15.4435 13.2762C15.0528 13.6669 14.8333 14.1968 14.8333 14.7493C14.8333 15.3019 15.0528 15.8318 15.4435 16.2225C15.8342 16.6132 16.3641 16.8327 16.9167 16.8327H33.5833V27.2494Z" fill="#16A34A"/>
              </svg>

              <h1 style="font-size: 32px; margin-left: 5px; color: #16A34A; font-weight: bold; margin-left: 20px;">{{ graph.quantidade_convenios_eixo }}</h1>
            </div>

            <h1 style="font-size: 20px; text-align: center; color: #16A34A; font-weight: bold;">Total de Convênios</h1>
          </div>
        </div>

        <div class='section-dashboard-right-item' :style="graph.convenios.eixos.open ? 'height: 100%;' : 'height: 156px; justify-content: center;'" @click="graph.convenios.eixos.open = graph.convenios.eixos.open" style=" display: flex; flex-direction: column; margin-top: 20px; border-radius: 10px; border: 2px solid #9CA3AF; border-color: #1B7E9F; padding: 10px;">
          <div style="display: flex; flex-direction: column; width: 100%; justify-content: center;">
            <div style="display: flex; align-items: center; justify-content: center;" :style="graph.convenios.eixos.open && 'margin-top: 10px;'">
              <svg width="38" height="42" viewBox="0 0 38 42" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M27.3333 37.666H10.6667C9.00906 37.666 7.41935 37.0075 6.24725 35.8354C5.07515 34.6633 4.41667 33.0736 4.41667 31.416V10.5827C4.41667 10.0301 4.19717 9.50025 3.80647 9.10954C3.41577 8.71884 2.88587 8.49935 2.33333 8.49935C1.7808 8.49935 1.25089 8.71884 0.860194 9.10954C0.469493 9.50025 0.25 10.0301 0.25 10.5827V31.416C0.25 34.1787 1.34747 36.8282 3.30097 38.7817C5.25447 40.7352 7.90399 41.8327 10.6667 41.8327H27.3333C27.8859 41.8327 28.4158 41.6132 28.8065 41.2225C29.1972 40.8318 29.4167 40.3019 29.4167 39.7494C29.4167 39.1968 29.1972 38.6669 28.8065 38.2762C28.4158 37.8855 27.8859 37.666 27.3333 37.666ZM37.75 14.6243C37.7283 14.433 37.6864 14.2444 37.625 14.0619V13.8743C37.5248 13.6601 37.3912 13.4632 37.2292 13.291L24.7292 0.791016C24.5569 0.628966 24.36 0.495351 24.1458 0.395182H23.9583L23.2917 0.166016H14.8333C13.1757 0.166016 11.586 0.824496 10.4139 1.9966C9.24181 3.1687 8.58333 4.75841 8.58333 6.41602V27.2494C8.58333 28.907 9.24181 30.4967 10.4139 31.6688C11.586 32.8409 13.1757 33.4994 14.8333 33.4994H31.5C33.1576 33.4994 34.7473 32.8409 35.9194 31.6688C37.0915 30.4967 37.75 28.907 37.75 27.2494V14.7493C37.75 14.7493 37.75 14.7493 37.75 14.6243ZM25.25 7.27018L30.6458 12.666H27.3333C26.7808 12.666 26.2509 12.4465 25.8602 12.0558C25.4695 11.6651 25.25 11.1352 25.25 10.5827V7.27018ZM33.5833 27.2494C33.5833 27.8019 33.3638 28.3318 32.9731 28.7225C32.5824 29.1132 32.0525 29.3327 31.5 29.3327H14.8333C14.2808 29.3327 13.7509 29.1132 13.3602 28.7225C12.9695 28.3318 12.75 27.8019 12.75 27.2494V6.41602C12.75 5.86348 12.9695 5.33358 13.3602 4.94288C13.7509 4.55218 14.2808 4.33268 14.8333 4.33268H21.0833V10.5827C21.0833 12.2403 21.7418 13.83 22.9139 15.0021C24.086 16.1742 25.6757 16.8327 27.3333 16.8327H33.5833V27.2494Z" fill="#1B7E9F"/>
              </svg>

              <h1 style="font-size: 32px; margin-left: 5px; color: #1B7E9F; font-weight: bold; margin-left: 20px;">{{ somarValores(graph.convenios.eixos.data) }}</h1>
            </div>

            <h1 style="font-size: 20px; text-align: center; color: #1B7E9F; font-weight: bold;">Total de Convênios por eixo</h1>

            <div v-if="graph.convenios.eixos.open" v-for="(item, index) in graph.convenios.eixos.data" style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; background-color: #f9f9f9; padding: 10px; border-radius: 15px; margin-bottom: 5px;">
              <h1 style="font-size: 14px; text-align: left; color: #1B7E9F; font-weight: bold; margin-bottom: 0;">{{ item.titulo }}</h1>
              <h1 style="font-size: 14px; text-align: left; color: #1B7E9F; font-weight: bold; margin-bottom: 0; margin-left: 10px;">{{ item.valor }}</h1>
            </div>
          </div>
        </div>

        <div class='section-dashboard-right-item' :style="graph.convenios.subeixos.open ? 'height: 100%;' : 'height: 156px; justify-content: center;'" @click="graph.convenios.subeixos.open = graph.convenios.subeixos.open" style=" display: flex; flex-direction: column; margin-top: 20px; border-radius: 10px; border: 2px solid #9CA3AF; border-color: #00A77B; padding: 10px;">
          <div style="display: flex; flex-direction: column; width: 100%; justify-content: center;">
            <div style="display: flex; flex-direction: column; width: 100%; justify-content: center;">
              <div style="display: flex; align-items: center; justify-content: center;" :style="graph.convenios.subeixos.open && 'margin-top: 10px;'">
                <svg width="42" height="46" viewBox="0 0 42 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M39.75 37.584H26.875C26.5639 36.7102 26.0623 35.9167 25.4065 35.2609C24.7506 34.605 23.9571 34.1034 23.0833 33.7923V29.2507H29.3333C30.9909 29.2507 32.5807 28.5922 33.7528 27.4201C34.9249 26.248 35.5833 24.6583 35.5833 23.0007V14.6673C35.5833 14.6673 35.5833 14.6673 35.5833 14.5423C35.5616 14.3509 35.5197 14.1624 35.4583 13.9798V13.7923C35.3582 13.5781 35.2246 13.3812 35.0625 13.209L22.5625 0.708984C22.3903 0.546935 22.1934 0.41332 21.9792 0.313151C21.917 0.304318 21.8539 0.304318 21.7917 0.313151C21.58 0.191779 21.3463 0.113868 21.1042 0.0839844H12.6667C11.0091 0.0839844 9.41936 0.742465 8.24726 1.91457C7.07515 3.08667 6.41667 4.67638 6.41667 6.33398V23.0007C6.41667 24.6583 7.07515 26.248 8.24726 27.4201C9.41936 28.5922 11.0091 29.2507 12.6667 29.2507H18.9167V33.7923C18.0429 34.1034 17.2494 34.605 16.5935 35.2609C15.9377 35.9167 15.4361 36.7102 15.125 37.584H2.25001C1.69747 37.584 1.16757 37.8035 0.776866 38.1942C0.386165 38.5849 0.166672 39.1148 0.166672 39.6673C0.166672 40.2199 0.386165 40.7498 0.776866 41.1405C1.16757 41.5312 1.69747 41.7506 2.25001 41.7506H15.125C15.5629 42.9572 16.3617 43.9997 17.4128 44.7364C18.464 45.4731 19.7164 45.8683 21 45.8683C22.2836 45.8683 23.536 45.4731 24.5872 44.7364C25.6383 43.9997 26.4371 42.9572 26.875 41.7506H39.75C40.3025 41.7506 40.8324 41.5312 41.2231 41.1405C41.6138 40.7498 41.8333 40.2199 41.8333 39.6673C41.8333 39.1148 41.6138 38.5849 41.2231 38.1942C40.8324 37.8035 40.3025 37.584 39.75 37.584ZM23.0833 7.18815L28.4792 12.584H25.1667C24.6141 12.584 24.0842 12.3645 23.6935 11.9738C23.3028 11.5831 23.0833 11.0532 23.0833 10.5007V7.18815ZM12.6667 25.084C12.1141 25.084 11.5842 24.8645 11.1935 24.4738C10.8028 24.0831 10.5833 23.5532 10.5833 23.0007V6.33398C10.5833 5.78145 10.8028 5.25155 11.1935 4.86085C11.5842 4.47014 12.1141 4.25065 12.6667 4.25065H18.9167V10.5007C18.9167 12.1583 19.5752 13.748 20.7473 14.9201C21.9194 16.0922 23.5091 16.7507 25.1667 16.7507H31.4167V23.0007C31.4167 23.5532 31.1972 24.0831 30.8065 24.4738C30.4158 24.8645 29.8859 25.084 29.3333 25.084H12.6667ZM21 41.7506C20.588 41.7506 20.1852 41.6285 19.8426 41.3995C19.5 41.1706 19.2329 40.8453 19.0753 40.4646C18.9176 40.0839 18.8763 39.665 18.9567 39.2609C19.0371 38.8568 19.2355 38.4855 19.5269 38.1942C19.8182 37.9028 20.1894 37.7044 20.5936 37.624C20.9977 37.5436 21.4166 37.5849 21.7973 37.7426C22.1779 37.9002 22.5033 38.1673 22.7322 38.5099C22.9612 38.8525 23.0833 39.2553 23.0833 39.6673C23.0833 40.2199 22.8638 40.7498 22.4731 41.1405C22.0824 41.5312 21.5525 41.7506 21 41.7506Z" fill="#00A77B"/>
                </svg>

                <h1 style="font-size: 32px; margin-left: 5px; color: #00A77B; font-weight: bold; margin-left: 20px;">{{ somarValores(graph.convenios.subeixos.data) }}</h1>
              </div>

              <h1 style="font-size: 20px; text-align: center; color: #00A77B; font-weight: bold;">Total de Convênios por Subeixo</h1>
            </div>

            <div v-if="graph.convenios.subeixos.open" v-for="(item, index) in graph.convenios.subeixos.data" style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; background-color: #f9f9f9; padding: 10px; border-radius: 15px; margin-bottom: 5px;">
              <h1 style="font-size: 14px; text-align: left; color: #00A77B; font-weight: bold; margin-bottom: 0;">{{ item.titulo }}</h1>
              <h1 style="font-size: 14px; text-align: left; color: #00A77B; font-weight: bold; margin-bottom: 0; margin-left: 10px;">{{ item.valor }}</h1>
            </div>
          </div>
        </div>

        <div class='section-dashboard-doughnut-right-item' style="height: 100%; display: flex; flex-direction: column; border-radius: 10px; margin-top: 20px; border: 2px solid #9CA3AF; border-color: #00A77B; padding: 10px;">
            <div>
              <b-form-group
                label-class="font-weight-bolder"
              >
                <b-form-select
                  v-model="tipo_grafico"
                  :options="tipos_grafico"
                >
                </b-form-select>
              </b-form-group>
            </div>

            <div v-for="(item, index) in graph.data.labels" style="display: flex; align-items: center;">
              <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="0.5" width="10" height="6" :fill="graph.data.datasets[0].backgroundColor[index]"/>
              <rect x="0.5" y="0.5" width="10" height="6" :stroke="graph.data.datasets[0].backgroundColor[index]"/>
              <rect x="0.5" y="0.5" width="10" height="6" stroke="black" stroke-opacity="0.2"/>
              </svg>
              <h1 style="font-size: 11px; margin-bottom: 0; margin-left: 5px;">{{ item }}</h1>
            </div>

            <div style="margin-top: 20px;"></div>

            <Doughnut
              :chart-options="{
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                  legend: {
                    display: false,
                  },
                },
              }"
              :chart-data="graph.data"
              :plugins="graph.plugins"
            />
        </div>
      </div>
    </div>

    <!-- <div class='section-dashboard-bottom'>
      <div class='section-dashboard-item-bottom' style="display: flex; justify-content: center; align-items: center; height: 156px; margin-top: 20px; border-radius: 10px; border: 2px solid #9CA3AF; border-color: #015675; padding: 10px;">
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
          <div style="display: flex; align-items: center;">
            <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.5833 29.3327C12.4121 29.3327 13.207 29.0034 13.793 28.4174C14.3791 27.8313 14.7083 27.0365 14.7083 26.2077C14.7185 26.1038 14.7185 25.9991 14.7083 25.8952L20.5208 20.0827H21H21.4792L24.8333 23.4369C24.8333 23.4369 24.8333 23.541 24.8333 23.6035C24.8333 24.4323 25.1626 25.2272 25.7486 25.8132C26.3347 26.3993 27.1295 26.7285 27.9583 26.7285C28.7871 26.7285 29.582 26.3993 30.168 25.8132C30.7541 25.2272 31.0833 24.4323 31.0833 23.6035V23.4369L38.6667 15.791C39.2847 15.791 39.8889 15.6077 40.4028 15.2644C40.9167 14.921 41.3173 14.4329 41.5538 13.8619C41.7903 13.2909 41.8522 12.6625 41.7316 12.0564C41.611 11.4502 41.3134 10.8933 40.8764 10.4563C40.4393 10.0193 39.8825 9.72164 39.2763 9.60106C38.6701 9.48048 38.0418 9.54237 37.4708 9.77889C36.8998 10.0154 36.4117 10.416 36.0683 10.9299C35.7249 11.4438 35.5417 12.0479 35.5417 12.666C35.5315 12.7699 35.5315 12.8746 35.5417 12.9785L28.0208 20.4994H27.6875L24.0833 16.8327C24.0833 16.0039 23.7541 15.209 23.168 14.623C22.582 14.0369 21.7871 13.7077 20.9583 13.7077C20.1295 13.7077 19.3347 14.0369 18.7486 14.623C18.1626 15.209 17.8333 16.0039 17.8333 16.8327L11.5833 23.0827C10.7545 23.0827 9.95968 23.4119 9.37362 23.998C8.78757 24.584 8.45833 25.3789 8.45833 26.2077C8.45833 27.0365 8.78757 27.8313 9.37362 28.4174C9.95968 29.0034 10.7545 29.3327 11.5833 29.3327ZM39.7083 37.666H4.29167V2.24935C4.29167 1.69681 4.07217 1.16691 3.68147 0.77621C3.29077 0.385509 2.76087 0.166016 2.20833 0.166016C1.6558 0.166016 1.12589 0.385509 0.735194 0.77621C0.344493 1.16691 0.125 1.69681 0.125 2.24935V39.7494C0.125 40.3019 0.344493 40.8318 0.735194 41.2225C1.12589 41.6132 1.6558 41.8327 2.20833 41.8327H39.7083C40.2609 41.8327 40.7908 41.6132 41.1815 41.2225C41.5722 40.8318 41.7917 40.3019 41.7917 39.7494C41.7917 39.1968 41.5722 38.6669 41.1815 38.2762C40.7908 37.8855 40.2609 37.666 39.7083 37.666Z" fill="#015675"/>
            </svg>

            <h1 style="font-size: 32px; margin-left: 5px; color: #015675; font-weight: bold; margin-left: 30px;">100.00</h1>
          </div>

          <h1 style="font-size: 20px; text-align: center; color: #015675; font-weight: bold;">Valor total do termo do Convênio</h1>
        </div>
      </div>

      <div class='section-dashboard-item-bottom' style="display: flex; justify-content: center; align-items: center; height: 156px; margin-top: 20px; border-radius: 10px; border: 2px solid #9CA3AF; border-color: #0FB899; padding: 10px;">
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
          <div style="display: flex; align-items: center;">
            <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 8.49935C20.4475 8.49935 19.9176 8.71884 19.5269 9.10954C19.1362 9.50025 18.9167 10.0301 18.9167 10.5827V31.416C18.9167 31.9686 19.1362 32.4985 19.5269 32.8892C19.9176 33.2799 20.4475 33.4994 21 33.4994C21.5526 33.4994 22.0825 33.2799 22.4732 32.8892C22.8639 32.4985 23.0834 31.9686 23.0834 31.416V10.5827C23.0834 10.0301 22.8639 9.50025 22.4732 9.10954C22.0825 8.71884 21.5526 8.49935 21 8.49935ZM10.5834 20.9994C10.0308 20.9994 9.50092 21.2188 9.11022 21.6095C8.71951 22.0002 8.50002 22.5301 8.50002 23.0827V31.416C8.50002 31.9686 8.71951 32.4985 9.11022 32.8892C9.50092 33.2799 10.0308 33.4994 10.5834 33.4994C11.1359 33.4994 11.6658 33.2799 12.0565 32.8892C12.4472 32.4985 12.6667 31.9686 12.6667 31.416V23.0827C12.6667 22.5301 12.4472 22.0002 12.0565 21.6095C11.6658 21.2188 11.1359 20.9994 10.5834 20.9994ZM31.4167 16.8327C30.8642 16.8327 30.3342 17.0522 29.9435 17.4429C29.5528 17.8336 29.3334 18.3635 29.3334 18.916V31.416C29.3334 31.9686 29.5528 32.4985 29.9435 32.8892C30.3342 33.2799 30.8642 33.4994 31.4167 33.4994C31.9692 33.4994 32.4991 33.2799 32.8898 32.8892C33.2805 32.4985 33.5 31.9686 33.5 31.416V18.916C33.5 18.3635 33.2805 17.8336 32.8898 17.4429C32.4991 17.0522 31.9692 16.8327 31.4167 16.8327ZM35.5834 0.166016H6.41669C4.75908 0.166016 3.16937 0.824496 1.99727 1.9966C0.825168 3.1687 0.166687 4.75841 0.166687 6.41602V35.5827C0.166687 37.2403 0.825168 38.83 1.99727 40.0021C3.16937 41.1742 4.75908 41.8327 6.41669 41.8327H35.5834C37.241 41.8327 38.8307 41.1742 40.0028 40.0021C41.1749 38.83 41.8334 37.2403 41.8334 35.5827V6.41602C41.8334 4.75841 41.1749 3.1687 40.0028 1.9966C38.8307 0.824496 37.241 0.166016 35.5834 0.166016ZM37.6667 35.5827C37.6667 36.1352 37.4472 36.6651 37.0565 37.0558C36.6658 37.4465 36.1359 37.666 35.5834 37.666H6.41669C5.86415 37.666 5.33425 37.4465 4.94355 37.0558C4.55285 36.6651 4.33335 36.1352 4.33335 35.5827V6.41602C4.33335 5.86348 4.55285 5.33358 4.94355 4.94288C5.33425 4.55218 5.86415 4.33268 6.41669 4.33268H35.5834C36.1359 4.33268 36.6658 4.55218 37.0565 4.94288C37.4472 5.33358 37.6667 5.86348 37.6667 6.41602V35.5827Z" fill="#0FB899"/>
            </svg>

            <h1 style="font-size: 32px; margin-left: 5px; color: #0FB899; font-weight: bold; margin-left: 30px;">10.000</h1>
          </div>

          <h1 style="font-size: 20px; text-align: center; color: #0FB899; font-weight: bold;">Valor total do termo por eixo</h1>
        </div>
      </div>

      <div class='section-dashboard-item-bottom' style="display: flex; justify-content: center; align-items: center; height: 156px; margin-top: 20px; border-radius: 10px; border: 2px solid #9CA3AF; border-color: #2D8D76; padding: 10px;">
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
          <div style="display: flex; align-items: center;">
            <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M39.75 25.166H37.6667V2.24935C37.6667 1.69681 37.4472 1.16691 37.0565 0.77621C36.6658 0.385509 36.1359 0.166016 35.5833 0.166016H6.41666C5.86412 0.166016 5.33422 0.385509 4.94352 0.77621C4.55282 1.16691 4.33332 1.69681 4.33332 2.24935V25.166H2.24999C1.69746 25.166 1.16755 25.3855 0.776851 25.7762C0.38615 26.1669 0.166656 26.6968 0.166656 27.2493C0.166656 27.8019 0.38615 28.3318 0.776851 28.7225C1.16755 29.1132 1.69746 29.3327 2.24999 29.3327H18.9167V31.7285L9.43749 37.9785C9.0486 38.2192 8.74974 38.5812 8.58701 39.0087C8.42428 39.4361 8.40673 39.9052 8.53706 40.3436C8.6674 40.782 8.93837 41.1653 9.30819 41.4345C9.678 41.7036 10.1261 41.8435 10.5833 41.8327C10.9929 41.8374 11.3937 41.7135 11.7292 41.4785L18.9167 36.7285V39.7493C18.9167 40.3019 19.1362 40.8318 19.5269 41.2225C19.9176 41.6132 20.4475 41.8327 21 41.8327C21.5525 41.8327 22.0824 41.6132 22.4731 41.2225C22.8638 40.8318 23.0833 40.3019 23.0833 39.7493V36.7285L30.2708 41.4785C30.6063 41.7135 31.0071 41.8374 31.4167 41.8327C31.8618 41.8292 32.2941 41.6833 32.6502 41.4164C33.0064 41.1494 33.2676 40.7753 33.3957 40.349C33.5239 39.9228 33.5121 39.4667 33.3621 39.0476C33.2122 38.6285 32.9319 38.2684 32.5625 38.0202L23.0833 31.7702V29.3327H39.75C40.3025 29.3327 40.8324 29.1132 41.2231 28.7225C41.6138 28.3318 41.8333 27.8019 41.8333 27.2493C41.8333 26.6968 41.6138 26.1669 41.2231 25.7762C40.8324 25.3855 40.3025 25.166 39.75 25.166ZM33.5 25.166H8.49999V4.33268H33.5V25.166ZM14.75 20.9993C15.0931 20.9976 15.4305 20.9111 15.7322 20.7475C16.0338 20.584 16.2904 20.3484 16.4792 20.0618L19.25 15.8952L21.6042 18.2702C21.8227 18.4901 22.0877 18.6585 22.3796 18.763C22.6716 18.8675 22.9831 18.9056 23.2917 18.8743C23.5988 18.8406 23.8946 18.739 24.1577 18.5769C24.4207 18.4147 24.6444 18.1961 24.8125 17.9368L28.9792 11.6868C29.2245 11.2294 29.2903 10.6969 29.1636 10.1935C29.0368 9.69009 28.7268 9.25215 28.2941 8.96542C27.8614 8.67868 27.3372 8.56381 26.8242 8.64331C26.3113 8.7228 25.8465 8.99093 25.5208 9.39518L22.75 13.5618L20.3958 11.1868C20.1772 10.9669 19.9123 10.7985 19.6204 10.694C19.3284 10.5895 19.0168 10.5515 18.7083 10.5827C18.4012 10.6164 18.1054 10.718 17.8423 10.8801C17.5793 11.0423 17.3556 11.2609 17.1875 11.5202L13.0208 17.7702C12.7193 18.2295 12.6114 18.7893 12.7207 19.3278C12.8299 19.8662 13.1475 20.3397 13.6042 20.6452C13.9397 20.8802 14.3404 21.004 14.75 20.9993Z" fill="#2D8D76"/>
            </svg>

            <h1 style="font-size: 32px; margin-left: 5px; color: #2D8D76; font-weight: bold; margin-left: 30px;">5.000</h1>
          </div>

          <h1 style="font-size: 20px; text-align: center; color: #2D8D76; font-weight: bold;">Valor total do termo por subeixo</h1>
        </div>
      </div>
    </div> -->

    <!-- <b-row class="mt-5 mb-4">
      <div
        v-if="loadingCards"
        class="spinner-border mx-auto text-primary"
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </div>
      <template v-else>
        <div
          class="col-12 col-md-4 py-3 py-md-0"
          v-for="(process, index) in processesCard"
          :key="index"
        >
          <b-card
            :class="`process-card ${process.color}-border-b`"
            class="shadow-sm pb-4 h-100 position-relative"
          >
            <h4 class="font-weight-normal">{{ process.title }}</h4>
            <h2 class="font-weight-bolder">{{ process.count }}</h2>
          </b-card>
        </div>
      </template>
    </b-row>
    <b-row class="mt-5">
      <b-col lg="12" class="mb-2" v-once>
        <h4 class="font-weight-bolder">Dados em gráficos</h4>
      </b-col>
      <b-col lg="12">
        <b-tabs pills card>
          <b-tab title="Processos criados" active>
            <apexchart
              ref="createdChart"
              width="100%"
              height="300px"
              type="bar"
              :options="chartOptions"
              :series="createdSeries"
            />
          </b-tab>
          <b-tab title="Processos arquivados">
            <apexchart
              ref="archivedChart"
              width="100%"
              height="300px"
              type="bar"
              :options="chartOptions"
              :series="archivedSeries"
            />
          </b-tab>
          <template #tabs-end v-once>
            <select class="ml-auto" v-model="filterByYear">
              <option value="2025">2025</option>
              <option value="2024">2024</option>
              <option value="2023">2023</option>
              <option value="2022">2022</option>
              <option value="2021">2021</option>
            </select>
          </template>
        </b-tabs>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col lg="12" v-once>
        <h4 class="font-weight-bolder">Últimos processos</h4>
      </b-col>
      <div
        v-if="loadingTable"
        class="spinner-border my-4 mx-auto text-primary"
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </div>
      <b-col v-else lg="12" class="table-responsive mt-4">
        <b-table striped hover :items="processTable" />
        <b-pagination
          v-if="paginatorOptions.total"
          v-model="paginatorOptions.page"
          :total-rows="paginatorOptions.total"
          :per-page="paginatorOptions.per_page"
          first-number
          last-number
          @input="(paginatorOptions.page = $event), getProcesses()"
          class="w-auto"
        />
      </b-col>
    </b-row> -->
  </main>
</template>

<script>
import {
  Chart as ChartJS,
  Title,
  ArcElement,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
} from 'chart.js'
import { Doughnut } from 'vue-chartjs'
import { watch } from 'vue'

ChartJS.register(ArcElement, CategoryScale, PointElement, LineElement, LinearScale, BarElement, Title, Tooltip, Legend)

import Map from '../components/Map.vue'

export default {
  components: {
    Map, Doughnut
  },
  name: 'Dashboard',
  data() {
    return {
      municipios: [
        // { value: 'Nenhum', text: 'Nenhum' },
        { value: 'Macapá', text: 'Macapá' },
        { value: 'Santana', text: 'Santana' },
        { value: 'Laranjal do Jari', text: 'Laranjal do Jari' },
        { value: 'Oiapoque', text: 'Oiapoque' },
        { value: 'Mazagão', text: 'Mazagão' },
        { value: 'Porto Grande', text: 'Porto Grande' },
        { value: 'Tartarugalzinho', text: 'Tartarugalzinho' },
        { value: 'Pedra Branca do Amaparí', text: 'Pedra Branca do Amaparí' },
        { value: 'Vitória do Jari', text: 'Vitória do Jari' },
        { value: 'Calçoene', text: 'Calçoene' },
        { value: 'Amapá', text: 'Amapá' },
        { value: 'Ferreira Gomes', text: 'Ferreira Gomes' },
        { value: 'Itaubal', text: 'Itaubal' },
        { value: 'Serra do Navio', text: 'Serra do Navio' },
        { value: 'Cutias', text: 'Cutias' },
        { value: 'Pracuúba', text: 'Pracuúba' },
      ],
      selectedMunicipio: 'Macapá',
      tipos_grafico: [
        { value: 'Convênios', text: 'Convênios' },
        { value: 'Valor', text: 'Valor' },
      ],
      tipo_grafico: 'Convênios',
      graph: {
        valor_total_termo_convenio: 0,
        termos: {
          eixos: {
            open: true,
            data: []
          },
          subeixos: {
            open: true,
            data: []
          }
        },
        quantidade_convenios_eixo: 0,
        convenios: {
          eixos: {
            open: true,
            data: []
          },
          subeixos: {
            open: true,
            data: []
          }
        },
        plugins: [
          {
            id: 'text',
            beforeDraw: function(chart) {
              // console.log(chart)
              var width = chart.width;
              var height = chart.height;
              var ctx = chart.ctx;

              ctx.restore();
              var fontSize = 1 //(height / 114).toFixed(2);
              ctx.font = fontSize + "em sans-serif";
              ctx.textBaseline = "middle";

              var text = chart?.config?.options?.value || (Number(chart?.config?.data?.datasets[0].data[0] || 0) + Number(chart?.config?.data?.datasets[0].data[1] || 0));
              /* text = isNaN(text) ? '' :  'R$ ' + new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(
                parseFloat(text)
              ) */
              text = Number(text).toLocaleString()
              var textX = Math.round((width - ctx.measureText(text).width) / 2);
              var textY = height / 2;

              ctx.fillText(text, textX, textY);
              ctx.save();
            }
          }
        ],
        data: {
          labels: [],
          datasets: [
            {
              label: '',
              backgroundColor: '',
              data: [0]
            },
          ]
        }
      },
      chartOptions: {
        chart: {
          id: 'dashboard',
        },
        noData: {
          text: 'Carregando dados...',
        },
      },
      createdSeries: [],
      archivedSeries: [],
      processesCard: [],
      processTable: [],
      paginatorOptions: {
        page: 1,
        total: null,
        per_page: null,
      },
      filterByYear: '2023',
      loadingTable: false,
      loadingCards: false,
    };
  },
  methods: {
    randomColor() {
      const rangeSize = 100; // adapt as needed
      const parts = [
          Math.floor(Math.random()*256),
          Math.floor(Math.random()*rangeSize),
          Math.floor(Math.random()*rangeSize) + 256-rangeSize
      ].sort( (a, b) => Math.random() < 0.5 );

      return parts.map( p => p.toString(16).padStart(2, "0") ).join('');
    },
    somarValores(array){
      let total = array.reduce(function (acumulador, valorAtual) {
        return acumulador + Number(valorAtual.valor);
      }, 0)

      return total
    },
    moneyMask(valor){
      return 'R$ ' + new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(
        parseFloat(valor)
      )
    },
    async getDashboard(municipio){
      const { data } = await this.$http.get('mapa', {
        params: {
          municipio
        }
      });

      const response = {
        valor_total_termo_convenio: Object.keys(data?.convenios).length == 0 ? 0 : Number(data?.convenios?.processos_sum_valor_convenio || 0),
        termos: {
          eixos: {
            open: true,
            data: data.eixos.map(item => ({
              titulo: item.descricao,
              valor: Number(item.total_valor_convenio || 0),
              color: `#${this.randomColor()}`
            }))
          },
          subeixos: {
            open: true,
            data: data.subeixos.map(item => ({
              titulo: item.descricao,
              valor: Number(item.total_valor_convenio || 0),
              color: `#${this.randomColor()}`
            }))
          }
        },
        quantidade_convenios_eixo: Object.keys(data?.convenios).length == 0 ? 0 : Number(data?.convenios?.processos_count || 0),
        convenios: {
          eixos: {
            open: true,
            data: data.eixos.map(item => ({
              titulo: item.descricao,
              valor: Number(item.qtd_processos || 0),
              color: `#${this.randomColor()}`
            }))
          },
          subeixos: {
            open: true,
            data: data.subeixos.map(item => ({
              titulo: item.descricao,
              valor: Number(item.qtd_processos || 0),
              color: `#${this.randomColor()}`
            }))
          },
        },
      }

      this.graph = {
        ...response,
        plugins: this.graph.plugins,
        valor_total_termo_convenio: response.valor_total_termo_convenio,
        quantidade_convenios_eixo: response.quantidade_convenios_eixo,
        data: this.tipo_grafico == 'Convênios' ? {
          labels: response.convenios.eixos.data.map(item => item.titulo),
          datasets: [
            {
              label: 'Total',
              backgroundColor: response.convenios.eixos.data.map(item => item.color),
              data: response.convenios.eixos.data.map(item => item.valor)
            },
          ]
        } : {
          labels: response.termos.eixos.data.map(item => item.titulo),
          datasets: [
            {
              label: 'Total',
              backgroundColor: response.termos.eixos.data.map(item => item.color),
              data: response.termos.eixos.data.map(item => item.valor)
            },
          ]
        }
      }
    },
    changeMunicipio(municipio){
      this.selectedMunicipio = municipio
    },
    async getProcesses() {
      this.loadingTable = true;
      try {
        const { data } = await this.$http.get('processos', {
          params: { page: this.paginatorOptions.page, limit: 5 },
        });
        this.populateTable(data.data);
        this.setPaginatorOptions(data);
      } catch (error) {
        console.error(error);
        this.loadingTable = false;
      }
    },
    async getArchivedData(archived) {
      try {
        const { data } = await this.$http.get('dashboard', {
          params: { ano: this.filterByYear, arquivados: archived },
        });
        return data;
      } catch (error) {
        console.log(error);
        this.loadingCards = false;
      }
    },
    populateCharts(createdChart, archivedChart) {
      this.createdSeries = [
        { name: 'Processos criados', data: [...createdChart] },
      ];
      this.archivedSeries = [
        { name: 'Processos arquivados', data: [...archivedChart] },
      ];
    },
    populateCards(data) {
      this.processesCard = [
        {
          title: 'Processos em análise',
          count: data.em_analise_count,
          color: 'warning',
        },
        {
          title: 'Processos arquivados',
          count: data.arquivados_count,
          color: 'danger',
        },
        {
          title: 'Processos totais',
          count: data.total_count,
          color: 'primary',
        },
      ];
      this.loadingCards = false;
    },
    populateTable(data) {
      this.processTable = data.map(process => {
        return {
          título: process.titulo,
          'Data de criação': new Date(process.created_at).toLocaleDateString(
            'pt-BR'
          ),
          prefeitura: process.prefeitura.nome,
        };
      });
      this.loadingTable = false;
    },
    setPaginatorOptions(data) {
      this.paginatorOptions.page = data.current_page;
      this.paginatorOptions.per_page = Number(data.per_page);
      this.paginatorOptions.total = data.total;
    },
  },
  beforeCreate() {
    //Check if profile is SDC, if not, redirect to home.
    if (JSON.parse(localStorage.getItem('user')).perfil.grupo_perfil_id != '1') {
      this.$router.push('/processos/minha-unidade');
    }
  },
  mounted() {
    this.loadingCards = true;
    Promise.all([
      this.getProcesses(),
      this.getArchivedData(false),
      this.getArchivedData(true),
    ])
      .then(res => {
        this.populateCharts(res[1].data, res[2].data);
        this.populateCards(res[1]);
      })
      .catch(error => {
        console.log(error);
      });

    this.getDashboard(this.selectedMunicipio)

    watch(
      () => this.tipo_grafico,
      () => {
        this.getDashboard(this.selectedMunicipio)
      }
    )

    watch(
      () => this.selectedMunicipio,
      () => {
        this.getDashboard(this.selectedMunicipio)
      }
    )
  },
  watch: {
    filterByYear() {
      Promise.all([this.getArchivedData(false), this.getArchivedData(true)])
        .then(res => {
          this.populateCharts(res[0].data, res[1].data);
        })
        .catch(error => console.log(error));
    },
  },
};
</script>

<style>
.process-card {
  border-radius: 8px !important;
  border: 1px #dee2e6 solid !important;
}
.primary-border-b {
  border-bottom: 4px #007bff solid !important;
}
.warning-border-b {
  border-bottom: 4px #ffc107 solid !important;
}
.danger-border-b {
  border-bottom: 4px #dc3545 solid !important;
}
</style>
